import { CircleHelp } from "lucide-react";
import { NewDot } from "@/components/NewDot.tsx";
import { Button } from "@/components/ui/button";
import { useHelp } from "@/lib/help.ts";
import { useNewChanges } from "@/lib/useNewChanges.ts";

/** The "?" in the masthead. A blue dot says there are updates you haven't looked at. */
export function HelpButton() {
  const show = useHelp((s) => s.show);
  const isNew = useNewChanges();
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => show("how")}
      aria-label={isNew ? "How to play and what's new. There are updates you haven't seen." : "How to play and what's new"}
      title={isNew ? "How to play · something new" : "How to play"}
      className="relative size-9"
    >
      <CircleHelp className="size-[1.15rem]" aria-hidden />
      {isNew && <NewDot className="absolute right-1.5 top-1.5" />}
    </Button>
  );
}
